import { render, staticRenderFns } from "./UiFrame.vue?vue&type=template&id=40b2cce1&scoped=true"
import script from "./UiFrame.vue?vue&type=script&lang=js"
export * from "./UiFrame.vue?vue&type=script&lang=js"
import style0 from "./UiFrame.vue?vue&type=style&index=0&id=40b2cce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2cce1",
  null
  
)

export default component.exports